import React from 'react';
import { InputBaseProps, InputLabel, Input as MUIInput } from '@mui/material';
import { Control, FieldPath, FieldValues, RegisterOptions } from 'react-hook-form';
import { useController, useId } from 'hooks';
import styles from './styles.module.sass';

type Properties<T extends FieldValues> = {
  control: Control<T, null>;
  name: FieldPath<T>;
  label: string;
  rules?: RegisterOptions<T, FieldPath<T>>;
} & InputBaseProps;

export const Input = <T extends FieldValues>({ control, name, label, rules, ...props }: Properties<T>) => {
  const { field, fieldState } = useController({ name, control, rules });
  const { value, onChange } = field;

  const id = useId();

  return (
    <div className={styles.container}>
      <InputLabel htmlFor={id} error={Boolean(fieldState.error)} className={styles.label}>
        {label}
      </InputLabel>
      <MUIInput
        {...props}
        className={styles.input}
        value={value}
        onChange={onChange}
        error={Boolean(fieldState.error)}
        id={id}
        name={name}
      />
      {fieldState.error && <div className={styles.error}>{fieldState.error.message}</div>}
    </div>
  );
};
